<template>
<div class="scanningrecord">
	<div class="scanningrecord-main">
		<ul class="scanningrecord-title">
			<li>
				<span>{{$t('changeinfos.changeinfostitle')}}</span>
			</li>
		</ul>
		<ul class="scanningrecord-info">
			<li v-for="(cordInfo,index) in cordsinfo">
				<span>{{cordInfo.lostTime}}</span>
				<p>{{cordInfo.lostaddress}}</p>
			</li>
		</ul>
		<ul class="scanningrecord-button">
			<li>
				<el-button type="button" @click='cordClose'>{{$t('changeinfos.sure')}}</el-button>
			</li>
		</ul>
	</div>
</div>
</template>

<script>
import axios from "axios";
import Qs from "qs";
import store from "../../store/store.js";
import {getLoginUser } from "../../api/index.js";
import { getScanner} from "../../ClientServerApi/index.js";
export default{
	name:'scanningrecords',
	data(){
		return{
			info:{
	            menuC:'',
	            cords:'',
            },
            cordsinfo:[],
            publishId:'',
		}
	},
	mounted(){
		
	},
	created(){
		this.open();
	},
	watch:{
		
	},
	methods: {
		//关闭扫码记录
		cordClose(){
			this.info.cords = false;
			this.$emit("cords",this.info);
		},				
		//获取二维码被扫码记录
	    open() {
	    	let pid = localStorage.publishId;
			this.publishid = pid;
	      	var params = Qs.stringify({
	            publishId : this.publishid,
	        });
	      getScanner(params)
	      .then(res=>{
	         console.log("获取次数：",res.data)
	        if (res.data.data.length > 0) {
	          if(res.data.header.status==1000){
	          	var strArr = [];
	            for(let i=0;i<res.data.data.length;i++){
	              //时间戳转换成日期
			        let   now = new Date(res.data.data[i].scannerTime);
		       		let   year=now.getFullYear();    
		         	let   month=now.getMonth()+1;    
		         	let   dates=now.getDate();    
		         	let   hour=now.getHours();    
		         	let   minute=now.getMinutes();    
		         	let   second=now.getSeconds();    
          
	              
	              //经纬度转换成地址信息
	              let addra = '';
				  let myGeo = new BMap.Geocoder();
	              let lng = res.data.data[i].lng;
	              let lat = res.data.data[i].lat;
	              let pt = new BMap.Point(lng,lat)
	              myGeo.getLocation(pt, function(rs){
	                // console.log("rs",rs)
	                let addComp = rs.addressComponents;
	                let addr = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
	                let losstime = year+"-"+month+"-"+dates+"   "+hour+":"+minute+":"+second;
	                if(losstime=='1970-1-1   8:0:0'){losstime=''}
	                strArr.push({lostTime : losstime,lostaddress:addr});
	              });
	            }
	            this.cordsinfo = strArr;
	          }
	        }
	        else {
	        	var strArr = [];
	        	let time = this.getNowFormatDate(time);
	        	strArr.push({lostTime : time,lostaddress:this.$t("prompt.noscan")});
	        	this.cordsinfo = strArr;
	        }
	      })
	      .catch(error => {
                console.log(error);
           });
	    },
	    //获取当前时间
	  	getNowFormatDate(time) {	  
		  	var date = new Date();
		  	var year = date.getFullYear();
		  	var month = date.getMonth() + 1;
		  	var strDate = date.getDate();
		  	if (month >= 1 && month <= 9) {
		   	 month = "0" + month;
		  	}
		  	if (strDate >= 0 && strDate <= 9) {
		    strDate = "0" + strDate;
		  	}
		  	var h =(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +":";
      		var m =(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      		var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
		  	var time = year + '-' + month + '-' + strDate +' ' + h + m + s;
		  	return time;
		},
	}
}
	
	
</script>

<style>
.scanningrecord{
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	z-index: 99999;
	overflow: auto;
	background: rgba(0,0,0,.6);
}
.scanningrecord-main{
	width: 92%;
	position: relative;
	top:20%;
	background: #fff;
	border-radius: 20px;
	margin: 0 auto;
	margin-bottom: 10%;
}
.scanningrecord-title{
	width: 100%;
}
.scanningrecord-title li{
	width: 100%;
	height: 3rem;
	line-height: 3rem;
	border-bottom: dashed 2px #b1b1b1;
	text-align: center;
}
.scanningrecord-title li span{
    font-size: 1rem;
    font-family: PingFangSC-Regular;
    font-weight: bold;
}
.scanningrecord-info li{
	width: 100%;
	height: 3.5rem;
	border-bottom: dashed 2px #b1b1b1;
	text-align: left;
}
.scanningrecord-info li span{
	display: inline-block;
	font-size: .6rem;
	text-indent: 10px;	
    padding: 8px 0;
}
.scanningrecord-info li p{
	font-size: .8rem;
	text-indent: 10px;	
}
.scanningrecord-button {
	width: 100%;
}
.scanningrecord-button li{
	width: 100%;
	padding: 30px 0;
}
.scanningrecord-button li .el-button--button { /*激活按钮*/
	display: block;
    width: 70%;
    margin: 0 auto;
    font-size: 1rem;
    height: 2.5rem;
    line-height: 2.5rem;
    color: rgb(255,255,255);
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}	
</style>


// WEBPACK FOOTER //
// src/m_page/login/scanningrecord.vue